import { FC } from 'react';

import { LinkedInIcon } from '@sparky/icons';

import ShareButton from './ShareButton';

const NETWORK_URL = 'https://www.linkedin.com/sharing/share-offsite/';
const NETWORK_PARAMETERS = {
  url: 'url',
};

type Props = {
  label: string;
};

const LinkedInButton: FC<Props> = ({ label }) => (
  <ShareButton label={label} networkParameters={NETWORK_PARAMETERS} networkUrl={NETWORK_URL}>
    <LinkedInIcon />
  </ShareButton>
);

export default LinkedInButton;
